import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms'
import { TypedFormGroup } from '@feature/forms/form-model';;
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

export type LabelPosition = 'before' | 'after';

@Component({
    selector: 'wai-form-toggle',
    templateUrl: './form-toggle.component.html',
    styleUrls: ['./form-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormToggleComponent implements AfterViewInit, OnChanges {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @HostBinding('class.wai-form-toggle') public className = true;
  @Input() public control: FormControl = new FormControl();
  /** Accepts `mat-icon` */
  @Input() public icon: string;
  @Input() public label: string;
  @Input() public isDisabled: boolean = false;
  @Input() public isChecked?: boolean = false;
  @Input() public labelPosition: LabelPosition = 'after';

  @Output() public changeValue = new EventEmitter<MatSlideToggleChange>();

  constructor(private cdr: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled'] && this.control) {
      this.updateDisabledState();
    }
  }

  ngAfterViewInit(): void {
    if (this.control.value === null && this.isChecked === true && this.isDisabled === true) {
      this.control.setValue(true);
    }

    this.updateDisabledState();
    this.cdr.detectChanges();
  }

  private updateDisabledState(): void {
    if (this.isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  public onChange(change: MatSlideToggleChange): void {
    this.changeValue.emit(change);
  }
}
